export default __webpack_public_path__ + "static/media/w_wdt_c_2.78cf3352.mp3";